/**
 * ProtectedRoute - redirect to /admin/login if not authenticated.
 * Optionally enforce admin-only routes.
 */
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user } = useAuth();
  const location = useLocation();

  // Still loading
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-slate-500">Loading...</div>
      </div>
    );
  }

  // Not authenticated
  if (user === false) {
    return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
  }

  // Admin-only route
  if (adminOnly && user.role !== "admin") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-slate-900 mb-2">Access Denied</h2>
          <p className="text-slate-500">This page is for administrators only.</p>
        </div>
      </div>
    );
  }

  return children;
}
